(function() {
  'use strict';

  var form = document.getElementById('klCtForm');
  if (!form) return;

  /* Shopify's {% form %} tag doesn't support novalidate — add it via JS */
  form.setAttribute('novalidate', '');

  var validators = {
    klCtName:    { error: 'klCtNameError',    check: function(v) { return v.length > 0; } },
    klCtEmail:   { error: 'klCtEmailError',   check: function(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); } },
    klCtMessage: { error: 'klCtMessageError', check: function(v) { return v.length > 0; } }
  };

  function validateField(id) {
    var c = validators[id];
    if (!c) return true;
    var el = document.getElementById(id);
    var err = document.getElementById(c.error);
    var valid = c.check(el.value.trim());
    el.classList.toggle('kl-ct-error', !valid);
    if (err) err.classList.toggle('kl-ct-visible', !valid);
    return valid;
  }

  function clearFieldError(id) {
    var c = validators[id];
    if (!c) return;
    document.getElementById(id).classList.remove('kl-ct-error');
    var err = document.getElementById(c.error);
    if (err) err.classList.remove('kl-ct-visible');
  }

  /* Blur validation with debounce */
  var blurTimers = {};
  Object.keys(validators).forEach(function(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('input', function() { clearFieldError(id); });
    el.addEventListener('blur', function() {
      clearTimeout(blurTimers[id]);
      blurTimers[id] = setTimeout(function() {
        if (el.value.trim().length > 0) validateField(id);
      }, 150);
    });
  });

  /* Submit — validate then let the browser submit natively.
     Shopify handles the POST, redirects to ?contact_posted=true,
     and Liquid renders the success state on the redirected page. */
  form.addEventListener('submit', function(e) {
    var nameOk = validateField('klCtName');
    var emailOk = validateField('klCtEmail');
    var msgOk = validateField('klCtMessage');

    if (!nameOk || !emailOk || !msgOk) {
      e.preventDefault();
      var first = form.querySelector('.kl-ct-error');
      if (first) first.focus();
      return;
    }

    /* Show sending state while page navigates */
    var submitBtn = document.getElementById('klCtSubmit');
    var label = submitBtn.querySelector('.kl-ct-submit-label');
    var arrow = submitBtn.querySelector('.kl-ct-submit-arrow');
    submitBtn.disabled = true;
    label.textContent = 'Sending\u2026';
    arrow.style.display = 'none';
  });

})();
